import { useCallback, useRef } from "react";
import { useEventListener } from "./useEventListener";

/**
 * One-time audio unlock helper.
 */
const useAutoUnlockAudio = (ids: string | string[]) => {
  const idList = Array.isArray(ids) ? ids : [ids];

  const unlockedRef = useRef(false);

  const unlockAudio = useCallback(() => {
    if (unlockedRef.current) {
      return;
    }

    let unlockedAny = false;

    for (const id of idList) {
      const el = document.getElementById(id);
      if (!el) continue;

      try {
        if (el instanceof HTMLVideoElement) {
          el.pause();
          el.muted = false;
          unlockedAny = true;
        } else if (el instanceof HTMLAudioElement) {
          el.pause();
          el.muted = false;
          unlockedAny = true;
        }
      } catch (error) {
        console.error("Failed to unlock media element", id, error);
      }
    }

    if (unlockedAny) {
      unlockedRef.current = true;
      // console.log("Audio unlocked for ids:", idList);
    }
  }, [JSON.stringify(idList)]);

  useEventListener("pointerdown", unlockAudio);
};

export default useAutoUnlockAudio;
